import { defineComponent } from "vue";
import { Moment } from "moment";
import { Container } from "aurelia-dependency-injection";

import { ITask } from "../../resources-vue/vue-interfaces/i-task";
import banner4 from "../../../img/axxess-intelligence44.png";
import banner5 from "../../../img/axxess-connect55.png";
import banner6 from "../../../img/axxess-central60.png";
import { AnalyticsCategory, AnalyticsService } from "../../services/analytics.service";

import TaskList from "./components/VisitSchedule/TaskList.vue";
import PastDue from "./components/PastDue/PastDue.vue";
import TaskAlerts from "./components/TaskAlerts/TaskAlerts.vue";
import TasksMap from "./components/TasksMap/TasksMap.vue";
import EmployeeList from "../Common/EmployeeList/EmployeeList.vue";
import PatientList from "../Common/PatientList/PatientList.vue";
import PersonalMessageList from "../Personal/components/PersonalMessageList/PersonalMessageList.vue";

export default defineComponent({
    components: {
        TaskList,
        PastDue,
        TaskAlerts,
        TasksMap,
        PersonalMessageList,
        EmployeeList,
        PatientList
    },
    data() {
        return {
            _analyticsServices: null as AnalyticsService,
            myTasksDate: {} as Moment,
            taskList: [] as ITask[],
            selectedTask: {} as ITask,
            router: null,
            listUpdate: 0,
            banners: [
                { src: banner4, link: "https://www.axxess.com/help/agencycore/axxess-intelligence/ask-axxess/" },
                { src: banner5, link: "https://www.axxess.com/help/axxess-central/axxess-connect/" },
                { src: banner6, link: "https://www.axxess.com/help/axxess-central/" }
            ],
            banner: { src: "", link: "" },
            intervalId: null as any,
            showBanner: true
        };
    },

    created() {
        this._analyticsServices = Container.instance.get(AnalyticsService);
        const randomIndex = Math.floor(Math.random() * this.banners.length);
        this.banner = this.banners[randomIndex];
    },

    mounted() {
        this.intervalId = setInterval(() => {
            const randomIndex = Math.floor(Math.random() * this.banners.length);
            this.banner = this.banners[randomIndex];
        }, 20000);
    },

    methods: {
        updateParentProps(updatedTaskList: ITask[], updatedMyTaskDate: Moment, updatedSelectedTask: ITask) {
            this.taskList = updatedTaskList;
            this.myTasksDate = updatedMyTaskDate;
            this.selectedTask = updatedSelectedTask;
        },

        updateTaskList(updatedTaskList: ITask[]) {
            this.taskList = updatedTaskList;
            this.listUpdate++;
        },
        selectedTaskChanged(task: ITask) {
            Object.assign(this.selectedTask, task);
        },
        closeBanner(banner: any) {
            let action = "";
            switch (banner.link) {
                case this.banners[0].link:
                    action = "Home page Banner (X/Close) - Axxess intelligence";
                    break;

                case this.banners[1].link:
                    action = "Home page Banner (X/Close) - Axxess Connect";
                    break;

                case this.banners[2].link:
                    action = "Home page Banner (X/Close) - Axxess Central";
                    break;

                default:
                    action = "Home page Banner (X/Close)";
            }
            this._analyticsServices.logEvent({
                category: AnalyticsCategory.Banners,
                action: action
            });
            this.showBanner = false;
            clearInterval(this.intervalId);
        },
        addLog(banner: any) {
            let action = "";
            switch (banner.Link) {
                case this.banners[0].link:
                    action = "Home page Banner  (click/redirect) - Axxess intelligence";
                    break;

                case this.banners[1].link:
                    action = "Home page Banner  (click/redirect) - Axxess Connect";
                    break;

                case this.banners[2].link:
                    action = "Home page Banner  (click/redirect) - Axxess Central";
                    break;

                default:
                    action = "Home page Banner (click/redirect)";
            }
            this._analyticsServices.logEvent({
                category: AnalyticsCategory.Banners,
                action: action
            });
        },
        addAgileLog() {
            this._analyticsServices.logEvent({
                category: AnalyticsCategory.Banners,
                action: "agile-banner"
            });
        }
    }
});
